import {createContext, useContext} from "react";

// Inside a section: may the user change things there («правка» in their roles) or only look («просмотр»)
export const SectionAccessContext = createContext({canEdit: false});

export const useCanEdit = () => useContext(SectionAccessContext).canEdit;
